import { Col, DatePicker, Input, message, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import { t } from 'i18next';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DateIcon } from '../../../asset';
import PrimaryButton from '../../../component/button/PrimaryButton';
import SecondaryButton from '../../../component/button/SecondaryButton';
import ModalSuccessAdd from '../../../component/modal/ModalSuccessAdd';
import ModalSuccessCompletion from '../../../component/modal/ModalSuccessCompletion';
import { GROLOG_URL } from '../../../constant/apiConstant';
import { ROUTES } from '../../../constant/routeConstant';
import { validDriver } from '../../master/fleet/driver/validation';
import { validCompletion } from './validation';
import style from "./completion.module.css";
import ModalConfirmLeave from '../../../component/modal/ModalConfirmLeave';
import { dropdownCustom, LoadingOption, selectOption } from '../../../component/select/SelectOption';

const LoginCompletion = () => {
  const {grologAccInfo} = useSelector((state)=>state.auth)
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [subdistrict, setSubdistrict] = useState([]);
  const [urbanvillage, setUrbanvillage] = useState([]);
  const [postalcode, setPostalcode] = useState([]);
  const [form, setForm] = useState([])
  const [error, setError] = useState([])
  const [modal, setModal] = useState(false) 
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm]=useState(false)
  const [change, setChange] = useState(false)
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  const [filter, setFilter] = useState("");
  const [loading,setLoading]=useState(false)
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  
  
  const api = GROLOG_URL;
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async (data) => {
    getListCountry(1, 10, "");
  }

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "POST";
    // const headers = { Authorization: tkn };
    const request = { url, method,data };
    return axios(request);
  };

  const onSubmit = async() =>{
    let errors={}
  let datas ={country_id: form?.country ? form.country : "",
  province_id: form?.province ? form.province : "",
  district_id: form?.district ? form.district : "",
  sub_district_id: form?.sub_district ? form.sub_district : "",
  urban_village_id: form?.urban_village ? form.urban_village : "",
  address: form?.address ? form.address : "",
  neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
  hamlet: form?.hamlet ? form.hamlet : "",
  postal_code: form?.postal_code ? form.postal_code : "",
  nik:form?.nik ? form.nik : "",
  birth_place:form?.birth_place ? form.birth_place : "",
  birth_date:form?.birth_date ? form.birth_date : "",
  }

  let datasub ={
    person_profile:{
    country: form?.country ? form.country : "",
  province: form?.province ? form.province : "",
  district: form?.district ? form.district : "",
  sub_district: form?.sub_district ? form.sub_district : "",
  urban_village: form?.urban_village ? form.urban_village : "",
  address: form?.address ? form.address : "",
  neighbourhood: form?.neighbourhood ? form.neighbourhood : "",
  hamlet: form?.hamlet ? form.hamlet : "",
  postal_code: form?.postal_code ? form.postal_code : "",
  nik:form?.nik ? form.nik : "",
  birth_place:form?.birth_place ? form.birth_place : "",
  birth_date:form?.birth_date ? form.birth_date : "",
  email:grologAccInfo?.email
    },
  user_registration:{
    client_id: grologAccInfo?.client_id
  }
  }

    for (const key in datas) {
      const option = validCompletion(key, datas[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }

    setError(errors);
    if (validateSubmit(errors)) {
      try{
        let res = await doPost(`/completion-user-invite`, token, datasub);
        setModal(true);
        // message.success(_.startCase("success completion"));
        // navigate(ROUTES.INDEX)
     
      }catch(err){
   message.error(_.startCase(err.response.data.payload.message));
     
      }
    }
  }

  
  const isZero = [];
  const getListCountry = async (page, limit, filter) => {
    const currentCountry = [...country];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${
        filter ? `&filter=name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = countrys?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      console.log("cek opt", option);
      // if (option.length>=1) {
        setCountry(selectOption(currentCountry, option, "value"));
      // } else {
      //   setCountry(selectOption(isZero, option, "value"));
      // }
      // setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const getListIsland = async (id) => {
    let island = await doGets(
      `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
      token
    );
    console.log(island?.data?.payload?.data);
    let list = [];
    island?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.name,
      });
    });
    setIsland(list);
  };

  const getListProvince = async (id, page, limit, filter, isChange) => {
    const currentProvince = [...province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setProvince(selectOption(isZero, option, "value"));   setProvince(selectOption(currentProvince, option, "value"));
      
      } else {
        setProvince(selectOption(currentProvince, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {
    const currentDistrict = [...district];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setDistrict(selectOption(isZero, option, "value"));
      } else {
        setDistrict(selectOption(currentDistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubdistrict = async (
    id,
    idprov,
    page,
    limit,
    filter,
    isChange
  ) => {
    const currentSubdistrict = [...subdistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setSubdistrict(selectOption(isZero, option, "value"));
      } else {
        setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanvillage = async (
    id,
    idprov,
    page,
    limit,
    filter,
    isChange
  ) => {
    const currentUrbanvillage = [...urbanvillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${
        filter ? `, name lk ${filter}` : ""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setUrbanvillage(selectOption(isZero, option, "value"));
      } else {
        setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListPostalCode = async (id, idprov) => {
    let district = await doGets(
      `/postal_code?page=1&limit=50&order=id&filter=urban_village_id eq ${idprov}&${param}`,
      token
    );
    console.log(district?.data?.payload?.data);
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.code,
      });
    });
    setPostalcode(list);
  };

  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry, "");
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };
  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value?.length >= 2) {
      setCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };

  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.country, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(form?.country, pageProvince, limitProvince, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(form?.country, pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(
        form?.country,
        form?.province,
        pageDistrict,
        limitDistrict,
        ""
      );
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  console.log("searchv", searchValue);
  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(
          form?.country,
          form?.province,
          pageDistrict,
          limitDistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(
        form?.country,
        form?.province,
        pageDistrict,
        limitDistrict,
        filter
      );
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubdistrict(
        form?.country,
        form?.district,
        pageSubdistrict,
        limitSubdistrict,
        ""
      );
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubdistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubdistrict(
          form?.country,
          form?.district,
          pageSubdistrict,
          limitSubdistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubdistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubdistrict(
        form?.country,
        form?.district,
        pageSubdistrict,
        limitSubdistrict,
        filter
      );
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanvillage(
        form?.country,
        form?.sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanvillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanvillage(
          form?.country,
          form?.sub_district,
          pageUrbanvillage,
          limitUrbanvillage,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanvillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanvillage(
        form?.country,
        form?.sub_district,
        pageUrbanvillage,
        limitUrbanvillage,
        filter
      );
    }
  };

  const handleChange = (value, name) => {
    
    // onChanged(dispatch, true)
    setChange(true);
    const isChange=true
    if (name === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else if (name === "country") {
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListIsland(value);
      getListProvince(value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validCompletion("country_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["island"]: "",
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "island") {
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListProvince(value);
      setSearchValue("")
      setFilter("")
      let eror = validCompletion("island_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["province"]: "",
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "province") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListDistrict(form.country, value,1,10,"",isChange);
      let eror = validCompletion("province_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["district"]: "",
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "district") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListSubdistrict(form.country, value,1,10,"",isChange);
      let eror = validCompletion("district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["sub_district"]: "",
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "sub_district") {
      setUrbanvillage([]);
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListUrbanvillage(form.country, value,1,10,"",isChange);
      let eror = validCompletion("sub_district_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["urban_village"]: "",
          ["postal_code"]: "",
        };
      });
    } else if (name === "urban_village") {
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListPostalCode(form.country, value,1,10,"",isChange);
      let eror = validCompletion("urban_village_id", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
          ["postal_code"]: "",
        };
      });
    } else if (name === "postal_code") {
      // getListSubdistrict(form.country, value);
      setSearchValue("")
      setFilter("")
      let eror = validCompletion("postal_code", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    }else if(name==="birth_date"){
      let eror = validCompletion(name, value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    }else {
      let eror = validCompletion(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };
  console.log("infoooo", grologAccInfo);
  const handleOk =()=>{
    setModal(false)
    navigate(ROUTES.INDEX)
  }
  return (
    <>
     {/* <ModalSuccessCompletion
    show={modal}
    action={()=>handleOk()}
    /> */}
    <ModalSuccessAdd
        show={modal}
        action={() => handleOk()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your account is created, please login again"
      />
      <div className='p-5 m-5 rounded-[10px] bg-[#FFFFFF]'>
        <div className='font-sans-bold text-[28px] text-black-100'>
          {t("LOGIN_COMPLETION:TITLE_PAGE")}
        </div>
        <div className='font-roboto-medium text-[16px] text-[#424242]'>
          {t("LOGIN_COMPLETION:SUB_TITLE_PAGE")}
        </div>

        <div className='font-roboto font-semibold text-[20px] mt-5'>
          {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
        </div>
        <div className='font-roboto text-[16px] text-[#424242]'>
          {t("LOGIN_COMPLETION:SUB_TITLE_LAYOUT")}
        </div>

        <div className='font-roboto-medium text-[18px] font-medium mt-3'>
          {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
        </div>

        <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_USERNAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.username}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_TITLE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.title}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_FIRST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.first_name}
                disabled
              />
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_GENDER")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.gender}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PHONE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.phone}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_LAST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.last_name}
                disabled
              />
            </div>
          </Col>
        </Row>

        <hr className='border border-[#D9D9D9] my-10' />

        <div className='font-roboto font-semibold text-[20px]'>
          {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
        </div>

        <Row>
          <Col span={10}>
            <div className='font-roboto-medium text-[18px] font-medium mt-3'>
              {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
            </div>
          </Col>
          <Col span={4}></Col>
          <Col span={10}>
            <div className='font-roboto-medium text-[18px] font-medium mt-3'>
              {t("LOGIN_COMPLETION:ADDRESS_INFORMATION")}
            </div>
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_EMAIL")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                disabled
                value={grologAccInfo?.email}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_EMAIL")} )}
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_NIK")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NIK")} )}
                status={error?.nik ? "error" : ""}
                
                onChange={(value) => handleChange(value, "nik")}
              />
              <div className="text-red-100">{error?.nik}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_BIRTH_PLACE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_PLACE")} )}
                status={error?.birth_place ? "error" : ""}
                
                onChange={(value) => handleChange(value, "birth_place")}
              />
              <div className="text-red-100">{error?.birth_place}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_BIRTH_DATE")}
              </p>
              <DatePicker
              disabledDate={(current)=> {
                return current && current.isAfter(moment().format('YYYY-MM-DD'))
              }}
                    format={"DD MMMM YYYY"}
                    status={error?.birth_date ? "error" : ""}
                    onChange={(e)=>handleChange(e, "birth_date")}
                    suffixIcon={<img src={DateIcon} alt="date" />}
                    className="h-[47px] w-[100%]"
                  />
                  
              <div className="text-red-100">{error?.birth_date}</div>
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_COUNTRY")}
              </p>
              <Select
                style={{ width: '100%' }} 
                    status={error?.country_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    value={form.country}
                    onChange={(value) => handleChange(value, "country")}
                    onPopupScroll={(e) => onScrollCountry(e)}
                    loading={loading}
                    // options={Country}
                    placeholder="Select Country"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeCountry(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? country : [...country, LoadingOption()]}
                  </Select>
              <div className="text-red-100">{error?.country_id}</div>
                </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PROVINCE")}
              </p>
              <Select
                    style={{ width: '100%' }}
                    disabled={!form.country}
                    value={form.province}
                    status={error?.province_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    onChange={(value) => handleChange(value, "province")}
                    onPopupScroll={(e) => onScrollProvince(e)}
                    loading={loading}
                    // options={Province}
                    placeholder="Select Province"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeProvince(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? province : [...province, LoadingOption()]}
                  </Select>
            <div className="text-red-100">{error?.province_id}</div>
                </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_DISTRICT")}
              </p>
              <Select
                    style={{ width: '100%' }}
                    status={error?.district_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    disabled={!form.province}
                    value={form.district}
                    size="large"
                    onChange={(value) => handleChange(value, "district")}
                    onPopupScroll={(e) => onScrollDistrict(e)}
                    loading={loading}
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeDistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? district : [...district, LoadingOption()]}
                  </Select>
            <div className="text-red-100">{error?.district_id}</div>
                </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_SUBDISTRICT")}
              </p>
              <Select
                    style={{ width: '100%' }}
                    status={error?.sub_district_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled={!form.district}
                    value={form.sub_district}
                    onChange={(value) => handleChange(value, "sub_district")}
                    onPopupScroll={(e) => onScrollSubdistrict(e)}
                    loading={loading}
                    // options={Subdistrict}
                    placeholder="Select Subdistrict"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeSubdistrict(value),
                        searchValue
                      )
                    }
                  >
                    {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                  </Select>
            <div className="text-red-100">{error?.sub_district_id}</div>
                </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")}
              </p>
              <Select
                    style={{ width: '100%' }}
                    status={error?.urban_village_id ? "error" : ""}
                    dropdownStyle={{
                      backgroundColor: "white",
                    }}
                    size="large"
                    disabled={!form.sub_district}
                    value={form.urban_village}
                    onChange={(value) => handleChange(value, "urban_village")}
                    onPopupScroll={(e) => onScrollUrbanvillage(e)}
                    loading={loading}
                    // options={Urbanvillage}
                    placeholder="Select depot Urbanvillage"
                    dropdownRender={(menu) =>
                      dropdownCustom(
                        menu,
                        (value) => onChangeUrbanvillage(value),
                        searchValue
                      )
                    }
                  >
                    {!loading
                      ? urbanvillage
                      : [...urbanvillage, LoadingOption()]}
                  </Select>
              <div className="text-red-100">{error?.urban_village_id}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_ADDRESS")}
              </p>
              <TextArea 
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS")} )}
                onChange={(value) => handleChange(value, "address")}
                status={error?.address ? "error" : ""}
                value={form.address}
              />

              <div className="text-red-100">{error?.address}</div>
            </div>

            <div className='mt-3'>
              <Row>
                <Col span={9}>
                  <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                    {t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")}
                  </p>
                </Col>
                <Col span={2}></Col>
                <Col span={9}>
                  <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                    {t("LOGIN_COMPLETION:LBL_HAMLET")}
                  </p>
                </Col>
                <Col span={4}></Col>
              </Row>

              <Row>
                <Col span={9}>
                  <Input 
                    style={{ width: '100%' }} 
                    size="large"
                    placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")} )}
                    onChange={(value) => handleChange(value, "neighbourhood")}
                    status={error?.neighbourhood ? "error" : ""}
                    value={form.neighbourhood}
                  />

                  <div className="text-red-100">{error?.neighbourhood}</div>
                
                </Col>
                <Col span={2}></Col>
                <Col span={9}>
                  <Input 
                    style={{ width: '100%' }} 
                    size="large"
                    placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_HAMLET")} )}
                    onChange={(value) => handleChange(value, "hamlet")}
                    status={error?.hamlet ? "error" : ""}
                    value={form.hamlet}
                  />

                  <div className="text-red-100">{error?.hamlet}</div>
                
                </Col>
                <Col span={4}></Col>
              </Row>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_POSTAL_CODE")}
              </p>
              <Select
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_POSTAL_CODE")} )}
                disabled={!form.urban_village}
                value={form.postal_code}
                onChange={(value) => handleChange(value, "postal_code")}
                options={postalcode}
                status={error?.postal_code ? "error" : ""}
                />

              <div className="text-red-100">{error?.postal_code}</div>
            
            </div>
          </Col>
        </Row>
      </div>
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.INDEX}
        iscompletion={true}
      />
      <div className='flex flex-row-reverse gap-[16px] px-5 mt-5 mb-10'>
        <PrimaryButton text={t("USER_DETAIL:SAVE")} action={()=>onSubmit()}/>
        <SecondaryButton text={t("USER_DETAIL:CANCEL")} action={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.INDEX)
            } />
      </div>
    </>
  );
}

export default LoginCompletion;